<template>
  <div class="card">
    <div class="card-body">
      <div v-if="error">
        {{ error }}
      </div>
      <h5 class="card-title text-muted">
        <strong> {{ $t('orders.list') }}</strong>
      </h5>
      <hr>
      <div class="table-responsive">
        <table class="table table-bordered table-striped p-2">
          <thead>
            <tr>
              <th scope="col">
                {{ $t('orders.orderNumber') }}
              </th>
              <th scope="col">
                {{ $t('orders.createAt') }}
              </th>
              <th scope="col">
                {{ $t('customer.company') }}
              </th>
              <th scope="col">
                {{ $t('customer.shippingAddress') }}
              </th>
              <th scope="col">
                {{ $t('orders.grandTotal') }}
              </th>
              <th scope="col">
                {{ $t('customer.serviceman') }}
              </th>
              <th scope="col">
                {{ $t('orders.status') }}
              </th>
            </tr>
          </thead>
          <div>
            <!--            {{ customerOrders.items }}-->
          </div>
          <tbody>
            <tr
              v-for="o in customerOrders"
              :key="o.increment_id"
              class="m-1 p-1 bg-light"
            >
              <td class="">
                <h6>{{ o.increment_id }}</h6>
              </td>
              <td class="">
                <h6>{{ o.created_at }}</h6>
              </td>
              <td class="">
                <h6>{{ o.customer_name }}</h6>
              </td>
              <td>
                <!--                         <span class="badge badge-pill badge-primary float-left">-->
                {{ o.shipping_address }}
                <!--                         </span>-->
              </td>
              <td>{{ o.grand_total }}</td>
              <td>{{ o.serviceman }}</td>
              <td>{{ o.status }}</td>
              <!--              <td>{{  }}</td>-->
              <td
                colspan="3"
                class="text-center"
              >
                <button
                  class="btn btn-success btn-sm text-center"
                  @click="handleSelectCustomerAddress(p)"
                >
                  {{ $t('buttons.select') }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <!--                <page-controls />-->
      </div>
    </div>
  </div>
</template>
<script>

import { getOrders } from '../services/orders'
import store from '../store';

export default {
  filters: {
    currency(value) {
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: "PLN"
      }).format(value);
    }
  },
  data: function() {
    return {
      orders: [],
      customerOrders:[],
      error: null
    }
  },
  async created() {
    await this.getOrders()
  },
  methods: {
    async getOrders() {
      let serviceMan = store.state.auth.user.serviceman;
      const response = await getOrders(serviceMan)
      this.customerOrders = response.data.customerPlacedOrder.allOrderRecords ? response.data.customerPlacedOrder.allOrderRecords.reverse() : null;
    }
  },

};
</script>
